import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { parseNewLines } from '@alfa-bank/site-helpers-common/react/parse-new-lines';
import { pascalize as pas } from '@alfa-bank/site-helpers-transform/strings/pascalize';

import type { THeading, TTags } from './models';

export const Heading: FC<React.PropsWithChildren<THeading>> = ({
    Font,
    Tag,
    children,
    className,
    configs,
    inline,
    keepStyles,
    lines,
    marginBottom = 'BodyText',
    marginTop = true,
    parentType = '',
    priority,
    size = 5,
    styles,
    theme = 'white',
    variant = 'main',
    ...rest
}) => {
    const tagByPriority = priority ? (`h${priority}` as TTags) : 'p';
    const TagName = Tag ?? (inline ? 'span' : tagByPriority);

    const hSize = `h${size}` as TTags;

    const { fontSize, lineHeight } = configs[hSize];

    const height = lines ? `calc(${lines} * ${lineHeight} * ${fontSize}px)` : undefined;

    // eslint-disable-next-line external-classname/specificity
    const classNames = cn(
        styles[variant],
        styles[`theme${pas(theme)}`],
        {
            [styles[`${hSize}${pas(variant)}`]]: !inline || (inline && keepStyles),
            [styles[`${hSize}MarginTopCommon`]]: !inline && marginTop && !parentType,
            [styles[`${hSize}MarginTopParent${pas(parentType)}`]]:
                !inline && marginTop && parentType,
            [styles[`${hSize}MarginBottom${pas(marginBottom || '')}`]]: !inline && marginBottom,
        },
        className
    );

    const heading = (
        <TagName className={classNames} style={{ height }} {...rest}>
            {parseNewLines(children)}
        </TagName>
    );

    if (variant === 'fancy') {
        return <Font>{heading}</Font>;
    }

    return heading;
};
